var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6365 0H4.36374V2.08256H0V6.69413C0 9.17925 1.96571 11.2052 4.42708 11.3021C4.86111 14.6616 7.47846 17.3368 10.8099 17.8582V21.6199H2.67783V24.0001H21.3225V21.6199H13.19V17.8582C16.5216 17.3369 19.1391 14.6618 19.5731 11.3021C22.0344 11.2051 24 9.17917 24 6.69413V2.08256H19.6365V0ZM4.36374 4.4629H2.3803V5.60339C2.3803 6.96191 3.19568 8.12997 4.36374 8.6449V4.4629ZM19.6365 8.64492V4.4629H21.62V5.60339C21.62 6.96192 20.8046 8.13 19.6365 8.64492Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.13e78030.svg";
export { ForwardRef as ReactComponent };